import { createAction } from 'redux-actions'

export const setCompletePaymentDetails = createAction(
  'SET_COMPLETE_PAYMENT_DETAILS'
)
export const setShouldTriggerPaymentInfoFetch = createAction(
  'SET_SHOULD_TRIGGER_PAYMENT_INFO_FETCH'
)
